import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import AuthApi from "../../api/authApi";
import WaitListCoupleApi from "../../api/WaitListCoupleApi";
import DatePicker from "../../components/AppDatePicker";
import { Form, Button, Row, Col, Table } from "react-bootstrap";
import moment from "moment-timezone";
import Loader from "../../components/loader";
import { useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import companyLogo from "../../assets/images/logo.png";
import AlertModal from "../../components/AlertModel";
import AlertDelete from "../../components/AlertDelete";
import OtherParishModal from "../../components/OtherParishModal";
import PhoneInput from "../../components/PhoneInput";
import axios from "axios";
import { formatParishOptionLabel } from "../../utils/parishLabels";

export const RegisterWaitList = () => {
  let authApi = new AuthApi();
  let waitListCoupleApi = new WaitListCoupleApi();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [selectedRetreat, setSelectedRetreat] = useState("");
  const [data, setData] = useState({
    hisFirstName: "",
    hisLastName: "",
    hisEmail: "",
    hisMobile: "",
    herFirstName: "",
    herLastName: "",
    herEmail: "",
    herMobile: "",
    city: "",
    state: "",
    zip: "",
    parishId: null,
    address: "",
    anniversary_date: "",
  });
  const [parishList, setParishList] = useState([]);
  const [selectedParish, setSelectedParish] = useState([]);
  const [LoadData, setLoadData] = useState(false);
  const [incommingRetreats, setIncommingRetreats] = useState([]);
  const [roles, setRoles] = useState([]);
  const [status, setStatus] = useState("");
  const [acknowledgments, setAcknowledgments] = useState({
    husband_acknowledgment: false,
    wife_acknowledgment: false,
  });
  const [acknowledgmentAlert, setAcknowledgmentAlert] = useState(false);
  const [show, setShow] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [matched, setMatched] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [otherParishModalOpen, setOtherParishModalOpen] = useState(false);
  const [emailErrors, setEmailErrors] = useState({
    hisEmail: "",
    herEmail: "",
  });
  const { id } = useParams();

  useEffect(() => {
    getParishList();
    getAllIncommingRetreats();
  }, []);

  const { t, i18n } = useTranslation();

  const getParishList = async () => {
    try {
      const response = await authApi.getPerishList();
      if (response.success) {
        let normalParishes = [];
        let otherParishes = [];
        response.data?.forEach((item) => {
          if (!item.parish) return;
          if (item.parishCategoryName?.toUpperCase() === "OTHER") {
            otherParishes.push({
              label: formatParishOptionLabel(item, { omitCategory: true }),
              value: item.id,
            });
          } else {
            normalParishes.push({
              label: formatParishOptionLabel(item),
              value: item.id,
            });
          }
        });
        normalParishes.sort((a, b) => a.label.localeCompare(b.label));
        otherParishes.sort((a, b) => a.label.localeCompare(b.label));
        const groupedOptions = [
          {
            label: "",
            options: [
              { label: "NONE / NINGUNA", value: null },
              { label: "OTHER / OTRA", value: "OTHER" },
            ],
          },
          {
            label: "Select Parish",
            options: normalParishes,
          },
          {
            label: "OTHER",
            options: otherParishes,
          },
        ];
        setParishList(groupedOptions);
      }
    } catch (error) {
      toast.error(error.toString());
    }
  };

  function getDayName(dateString, language) {
    const dateInUSTimezone = moment(dateString).tz("America/New_York");
    let days = [];
    if (language === "spanish") {
      days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
    } else {
      days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
    }
    return days[dateInUSTimezone.day()];
  }

  const getAllIncommingRetreats = async () => {
    setLoadData(true);
    await authApi
      .getAllIncommingRetreats()
      .then(async (response) => {
        await authApi
          .getPerishList()
          .then((r) => {
            response.data.forEach((event) => {
              let myparish = r.data.find((i) => i.id === event.parishId);
              if (myparish) {
                event.myparish = myparish;
              }
              event.schedule.forEach((item) => {
                item.dayName = getDayName(item.date, event.language);
              });
            });
          })
          .catch((error) => {
            toast.error(error.toString());
          });
        if (id) {
          getRolesOfRetreats(id);
          let findRetreat = response.data.find((item) => item.id == id);
          setIncommingRetreats(response.data);
          if (findRetreat) {
            i18n.changeLanguage(findRetreat.language);
            setSelectedRetreat(findRetreat);
            setStatus({
              directoryStatus: findRetreat.directoryStatus,
              programStatus: findRetreat.programStatus,
            });
          } else {
            alert("The Retreat ID you entered does not exist.");
            navigate("/registration-retreat");
          }
        } else {
          setIncommingRetreats(response.data);
          if (response && response.data[0] && response.data[0].id) {
            // getRolesOfRetreats(response.data[0].id);
            navigate(`/registration-retreat/${response.data[0].id}`);
            i18n.changeLanguage(response.data[0].language);
          }
          setSelectedRetreat(response.data[0]);
          setStatus({
            directoryStatus: response.data[0].directoryStatus,
            programStatus: response.data[0].programStatus,
          });
        }
        setLoadData(false);
      })
      .catch((error) => {
        toast.error(error.toString());
        setLoadData(false);
      });
  };

  const getRolesOfRetreats = async (id) => {
    await authApi.getRolesOfRetreats({ id: id }).then(async (response) => {
      setRoles(response.data);
    });
  };

  const handleDatePicker = (e) => {
    let o = { ...data };
    o.anniversary_date = e;
    setData(o);
  };

  const handleChanges = (e) => {
    let { name, value } = e.target;
    let d = { ...data };
    if (name === "imageUrl") {
      const file = e.target.files[0];
      if (file) {
        const fileSizeInMB = file.size / (1024 * 1024); // Convert size from bytes to MB
        if (fileSizeInMB > 3) {
          alert("File size should be less than 3 MB");
          return;
        } else {
          d[name] = file;
          const successMessage =
            name === "imageUrl"
              ? "The profile image has been successfully added."
              : "";
          toast.success(successMessage);
        }
      }
    } else {
      d[name] = value;
    }

    if (name === "hisEmail" || name === "herEmail") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        setEmailErrors((prev) => ({ ...prev, [name]: "Invalid email format" }));
      } else {
        setEmailErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }

    setData(d);
  };

  const handleSelectParish = (val) => {
    setSelectedParish(val);
    let d = { ...data };
    if (val.value === "OTHER") {
      setOtherParishModalOpen(true);
      d.parishId = null;
    } else {
      d.parishId = val.value;
    }
    setData(d);
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity()) {
      let data1 = new FormData();
      data1.append("file", data.imageUrl);
      let stateRef = { ...data };
      delete stateRef.imageUrl;
      stateRef.retreatId = selectedRetreat.id;
      data1.append("fromData", JSON.stringify(stateRef));

      if (
        acknowledgments.husband_acknowledgment &&
        acknowledgments.wife_acknowledgment
      ) {
        setTimeout(() => {
          const element = document.getElementById("section-1");
          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
          }
        }, 500);
        authApi
          .registerCouple(data1)
          .then(async (res) => {
            if (res.success) {
              toast.success(t("couple_register_retreat_msg"));
              clearfield();
              setData({
                id: "",
                hisFirstName: "",
                hisLastName: "",
                hisEmail: "",
                hisMobile: "",
                herFirstName: "",
                herLastName: "",
                herEmail: "",
                herMobile: "",
                city: "",
                state: "",
                zip: "",
                address: "",
                anniversary_date: "",
              });

              navigate("/thankyou", {
                state: {
                  value: "Register WaitList Couple",
                  data: selectedRetreat,
                },
              });
            } else {
              if (res.msg == "Please add at least one name.") {
                toast.error(t("add_one_name"));
              } else if (res.msg == "Please add at least one email ID.") {
                toast.error(t("least_email_id"));
              } else if (
                res.msg == "Please select either a Retreatant or a Team Couple."
              ) {
                toast.error(t("ret_team_selection"));
              } else if (res.msg == "This Mobile is already used.") {
                toast.error(t("mobile_used"));
              } else if (
                res.msg ==
                "You are already registered for this Retreat with this Email id."
              ) {
                toast.error(t("already_registered"));
              } else {
                toast.error(res.msg);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        setAcknowledgmentAlert(true);
      }
    } else {
      setValidated(true);
    }

    if (emailErrors.hisEmail || emailErrors.herEmail) {
      toast.error("Please enter valid email addresses.");
      return;
    }
  };

  const clearfield = () => {
    setData({
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      hisMobile: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
      herMobile: "",
      city: "",
      state: "",
      zip: "",
      parishId: null,
      address: "",
      anniversary_date: "",
    });
    setSelectedParish([]);
    setValidated(false);
    setEmailErrors({
      hisEmail: "",
      herEmail: "",
    });
  };

  const acknowledgmentCheckbox = (e) => {
    const { name, checked } = e.target;

    // Update acknowledgment state first
    const updatedState = {
      ...acknowledgments,
      [name]: checked,
    };

    // Disable alert if both checkboxes are checked
    if (
      updatedState.husband_acknowledgment &&
      updatedState.wife_acknowledgment
    ) {
      setAcknowledgmentAlert(false);
    }

    setAcknowledgments(updatedState);
  };

  const handleClose = () => {
    setData({
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      hisMobile: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
      herMobile: "",
      city: "",
      state: "",
      zip: "",
      parishId: null,
      address: "",
      anniversary_date: "",
    });
    setEmailErrors({
      hisEmail: "",
      herEmail: "",
    });
    setShow(false);
    setShowInfo(true);
    setMatched(false);
  };

  const coupleMatched = () => {
    setShow(false);
    setShowInfo(true);
    setMatched(true);
  };

  const handleCloseInfoAlert = () => {
    setShowInfo(false);
  };

  const handleSearch = async (e) => {
    const value = e.target.value;
    handleChanges(e); // keep your original logic

    if (value.length > 2) {
      try {
        const res = await axios.get(
          `https://nominatim.openstreetmap.org/search?format=json&q=${value}`
        );
        console.log("res---->", res);

        setSuggestions(res.data);
      } catch (error) {
        console.error("Error fetching address suggestions:", error);
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (address) => {
    handleChanges({
      target: { name: "address", value: address.display_name },
    });
    setSuggestions([]);
  };

  return (
    <>
      <div className="container-scroller mainpannel">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
          {LoadData ? (
            <div className="content-wrapper align-items-center auth px-0">
              <div className="row w-100 mx-0">
                <div className="col-lg-10 mx-auto">
                  <div className="auth-form-light text-center main-register py-5 px-4 px-sm-5">
                    <Loader />
                  </div>
                </div>
              </div>
            </div>
          ) : incommingRetreats && incommingRetreats.length ? (
            <div className="content-wrapper  align-items-center auth px-0">
              <div className="row w-100 mx-0">
                <div className="col-md-12">
                  {" "}
                  <div className="compLogo">
                    <img src={companyLogo} alt="logo" className="logo center" />
                  </div>
                </div>
              </div>
              <Row className="w-100 mx-0 justify-content-center mt-5">
                <Col lg={12} md={12} xs={12} className="text-center">
                  <h3 className="RegisTitle">{t("registration_form")}</h3>
                </Col>
                <Col
                  lg={10}
                  md={10}
                  xs={10}
                  className="text-end requiredFieldMsg"
                >
                  <span className="highlightedText">
                    {t("highlighted_text")}
                  </span>
                  <Link
                    to="/create-ticket"
                    state={{ pageName: "registration-retreat" }}
                    href="blank"
                  >
                    <div className="helpDiv">
                      <span className="helpMdi">{t("help")}</span>
                      <i
                        className="mdi mdi-help-circle"
                        style={{ fontSize: "22px" }}
                      ></i>
                    </div>
                  </Link>
                </Col>
              </Row>
              <div className="row w-100 mx-0">
                <div className="col-lg-10 mx-auto">
                  <div className="auth-form-light text-left main-register-check py-5 px-4 px-sm-5">
                    <Form
                      onSubmit={handleSubmit}
                      noValidate
                      validated={validated}
                      className="forms-sample formStyle"
                    >
                      <Row>
                        <Col lg={6} md={6} xs={12}>
                          <label className="badge badge-outline-primary rounded mb-3 mt-2 hisLabel">
                            {t("his_info")}
                          </label>
                          <div id="his-info">
                            <Col lg={12} md={12} xs={12}>
                              <Form.Group className="form-group">
                                <Form.Label
                                  className={
                                    data.hisFirstName
                                      ? "his-info"
                                      : "highlightField1 mt-2 his-info"
                                  }
                                >
                                  {t("his_first_name")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  // required
                                  size="sm"
                                  type="text"
                                  name="hisFirstName"
                                  id="hisFirstName"
                                  placeholder={`${t("his_first_name")}`}
                                  value={data.hisFirstName}
                                  className="form-control his-info-border"
                                  onChange={(e) => handleChanges(e)}
                                />
                                <Form.Control.Feedback type="invalid">
                                  FirstName is required!
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col lg={12} md={12} xs={12}>
                              <Form.Group className="form-group">
                                <Form.Label
                                  className={
                                    data.hisLastName ? null : "highlightField1"
                                  }
                                >
                                  {" "}
                                  {t("his_last_name")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  // required
                                  size="sm"
                                  type="text"
                                  name="hisLastName"
                                  id="hisLastName"
                                  placeholder={`${t("his_last_name")}`}
                                  value={data.hisLastName}
                                  className="form-control"
                                  onChange={(e) => handleChanges(e)}
                                />
                                <Form.Control.Feedback type="invalid">
                                  LastName is required!
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col lg={12} md={12} xs={12}>
                              <Form.Group className="form-group col">
                                <Form.Label
                                  className={
                                    data.hisEmail ? null : "highlightField1"
                                  }
                                >
                                  {t("his_email")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  // required
                                  size="sm"
                                  type="text"
                                  name="hisEmail"
                                  id="hisEmail"
                                  placeholder={`${t("his_email")}`}
                                  value={data.hisEmail}
                                  onChange={(e) => handleChanges(e)}
                                />
                                {emailErrors.hisEmail && (
                                  <span
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {emailErrors.hisEmail}
                                  </span>
                                )}
                                <Form.Control.Feedback type="invalid">
                                  Email is required!
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col lg={12} md={12} xs={12}>
                              <Form.Group className="form-group col">
                                <Form.Label
                                  className={
                                    data.hisMobile ? null : "highlightField1"
                                  }
                                >
                                  {t("his_mobile")}
                                </Form.Label>
                                <PhoneInput
                                  name="hisMobile"
                                  value={data.hisMobile}
                                  onChange={(e) => handleChanges(e)}
                                />
                                <Form.Control.Feedback type="invalid">
                                  Mobile is required!
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          </div>
                        </Col>
                        <Col lg={6} md={6} xs={12}>
                          <label className="badge badge-outline-primary rounded mb-3 mt-2 herLabel">
                            {t("her_info")}
                          </label>
                          <div id="her-info">
                            <Col lg={12} md={12} xs={12}>
                              <Form.Group className="form-group">
                                <Form.Label
                                  className={
                                    data.herFirstName
                                      ? "her-info"
                                      : "highlightField1 mt-2 her-info"
                                  }
                                >
                                  {t("her_first_name")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  // required
                                  size="sm"
                                  type="text"
                                  name="herFirstName"
                                  id="herFirstName"
                                  placeholder={`${t("her_first_name")}`}
                                  value={data.herFirstName}
                                  onChange={(e) => handleChanges(e)}
                                  className="her-info-border"
                                />
                                <Form.Control.Feedback type="invalid">
                                  FirstName is required!
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col lg={12} md={12} xs={12}>
                              <Form.Group className="form-group">
                                <Form.Label
                                  className={
                                    data.herLastName ? null : "highlightField1"
                                  }
                                >
                                  {" "}
                                  {t("her_last_name")}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  // required
                                  size="sm"
                                  type="text"
                                  name="herLastName"
                                  id="herLastName"
                                  placeholder={`${t("her_last_name")}`}
                                  value={data.herLastName}
                                  onChange={(e) => handleChanges(e)}
                                />
                                <Form.Control.Feedback type="invalid">
                                  LastName is required!
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col lg={12} md={12} xs={12}>
                              <Form.Group className="form-group">
                                <Form.Label
                                  className={
                                    data.herEmail ? null : "highlightField1"
                                  }
                                >
                                  {t("her_email")}{" "}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  // required
                                  size="sm"
                                  type="text"
                                  name="herEmail"
                                  id="herEmail"
                                  placeholder={`${t("her_email")}`}
                                  value={data.herEmail}
                                  onChange={(e) => handleChanges(e)}
                                />
                                {emailErrors.herEmail && (
                                  <span
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {emailErrors.herEmail}
                                  </span>
                                )}
                                <Form.Control.Feedback type="invalid">
                                  Email is required!
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col lg={12} md={12} xs={12}>
                              <Form.Group className="form-group">
                                <Form.Label
                                  className={
                                    data.herMobile ? null : "highlightField1"
                                  }
                                >
                                  {t("her_mobile")}
                                </Form.Label>
                                <PhoneInput
                                  name="herMobile"
                                  value={data.herMobile}
                                  onChange={(e) => handleChanges(e)}
                                />
                                <Form.Control.Feedback type="invalid">
                                  Mobile is required!
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          </div>
                        </Col>
                      </Row>
                      <div id="section-1"></div>
                      <hr></hr>
                      <div className="row locationFields">
                        <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <Form.Label
                            className={data.address ? null : "highlightField1"}
                          >
                            {t("address")}
                          </Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="address"
                            id="address"
                            placeholder={`${t("address")}`}
                            value={data.address}
                            onChange={(e) => handleChanges(e)}
                          />
                          <Form.Control.Feedback type="invalid">
                            Address is required!
                          </Form.Control.Feedback>
                        </Form.Group>
                        {/* <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <Form.Label
                            className={data.address ? null : "highlightField"}
                          >
                            {t("address")}
                          </Form.Label>
                          <Form.Control
                            size="sm"
                            type="text"
                            name="address"
                            id="address"
                            placeholder={`${t("address")}`}
                            value={data.address}
                            onChange={handleSearch}
                            autoComplete="off"
                          />
                          <Form.Control.Feedback type="invalid">
                            Address is required!
                          </Form.Control.Feedback>
                          {suggestions.length > 0 && (
                            <ul
                              className="list-group w-100 mt-1"
                              style={{
                                zIndex: 1000,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }}
                            >
                              {suggestions.map((address) => (
                                <li
                                  key={address.place_id}
                                  onClick={() => handleSelect(address)}
                                  className="list-group-item list-group-item-action"
                                  style={{ cursor: "pointer" }}
                                >
                                  {address.display_name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </Form.Group> */}

                        <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <Form.Label
                            className={data.state ? null : "highlightField1"}
                          >
                            {t("state")}
                          </Form.Label>
                          <Form.Select
                            className="minimal locationDropdown"
                            size="sm"
                            type="text"
                            name="state"
                            id="state"
                            placeholder={`${t("state")}`}
                            value={data.state}
                            onChange={(e) => handleChanges(e)}
                          >
                            <option value="">{t("select_state")}</option>
                            <option value="Alaska">Alaska</option>
                            <option value="Alabama">Alabama</option>
                            <option value="Arkansas">Arkansas</option>
                            <option value="Arizona">Arizona</option>
                            <option value="California">California</option>
                            <option value="Colorado">Colorado</option>
                            <option value="Connecticut">Connecticut</option>
                            <option value="District of Columbia">
                              District of Columbia
                            </option>
                            <option value="Delaware">Delaware</option>
                            <option value="Florida">Florida</option>
                            <option value="Georgia">Georgia</option>
                            <option value="Hawaii">Hawaii</option>
                            <option value="Iowa">Iowa</option>
                            <option value="Idaho">Idaho</option>
                            <option value="Illinois">Illinois</option>
                            <option value="Indiana">Indiana</option>
                            <option value="Kansas">Kansas</option>
                            <option value="Kentucky">Kentucky</option>
                            <option value="Louisiana">Louisiana</option>
                            <option value="Massachusetts">Massachusetts</option>
                            <option value="Maryland">Maryland</option>
                            <option value="Maine">Maine</option>
                            <option value="Michigan">Michigan</option>
                            <option value="Minnesota">Minnesota</option>
                            <option value="Missouri">Missouri</option>
                            <option value="Mississippi">Mississippi</option>
                            <option value="Montana">Montana</option>
                            <option value="North Carolina<">
                              North Carolina
                            </option>
                            <option value="North Dakota">North Dakota</option>
                            <option value="Nebraska">Nebraska</option>
                            <option value="New Hampshire">New Hampshire</option>
                            <option value="New Jersey">New Jersey</option>
                            <option value="New Mexico">New Mexico</option>
                            <option value="Nevada">Nevada</option>
                            <option value="New York">New York</option>
                            <option value="Ohio">Ohio</option>
                            <option value="Oklahoma">Oklahoma</option>
                            <option value="Oregon">Oregon</option>
                            <option value="Pennsylvania">Pennsylvania</option>
                            <option value="Puerto Rico">Puerto Rico</option>
                            <option value="Rhode Island">Rhode Island</option>
                            <option value="South Carolina">
                              South Carolina
                            </option>
                            <option value="South Dakota">South Dakota</option>
                            <option value="Tennessee">Tennessee</option>
                            <option value="Texas">Texas</option>
                            <option value="Utah">Utah</option>
                            <option value="Virginia">Virginia</option>
                            <option value="Vermont">Vermont</option>
                            <option value="Washington">Washington</option>
                            <option value="Wisconsin">Wisconsin</option>
                            <option value="West Virginia">West Virginia</option>
                            <option value="Wyoming">Wyoming</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            State is required!
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <Form.Label
                            className={data.city ? null : "highlightField1"}
                          >
                            {t("city")}
                          </Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="city"
                            id="city"
                            placeholder={`${t("city")}`}
                            value={data.city}
                            onChange={(e) => handleChanges(e)}
                          />
                          <Form.Control.Feedback type="invalid">
                            City is required!
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <Form.Label
                            className={data.zip ? null : "highlightField1"}
                          >
                            {t("zip")}
                          </Form.Label>
                          <Form.Control
                            // required
                            size="sm"
                            type="text"
                            name="zip"
                            id="zip"
                            placeholder={`${t("zip")}`}
                            value={data.zip}
                            onChange={(e) => handleChanges(e)}
                          />
                          <Form.Control.Feedback type="invalid">
                            Zip is required!
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <Form.Label>{t("parish")}</Form.Label>
                          <Select
                            name="parish"
                            options={parishList}
                            value={selectedParish}
                            onChange={handleSelectParish}
                            labelledBy="Select"
                            placeholder={`${t("select_parish")}`}
                            isSearchable={true}
                            isMulti={false}
                          />
                          <span>{data.parishName}</span>
                          <Form.Control.Feedback type="invalid">
                            Parsih is required!
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <Form.Label className="d-block">
                            {t("anniversary_date")}
                          </Form.Label>

                          <DatePicker
                            autoComplete="off"
                            dateFormat="MM-dd-yyyy"
                            placeholderText="mm-dd-yyyy"
                            selected={data?.anniversary_date}
                            onChange={(date) => handleDatePicker(date)}
                            className="form-select setdate datepicker"
                            name="anniversary_date"
                            id="anniversary_date"
                            maxDate={new Date()}
                            showDisabledMonthNavigation
                            renderCustomHeader={({
                              date,
                              changeYear,
                              changeMonth,
                              decreaseMonth,
                              increaseMonth,
                              prevMonthButtonDisabled,
                              nextMonthButtonDisabled,
                            }) => {
                              const years = Array.from(
                                { length: 100 },
                                (_, i) => new Date().getFullYear() - i
                              );
                              const months = [
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December",
                              ];

                              return (
                                <div
                                  style={{
                                    textAlign: "center",
                                    paddingBottom: "8px",
                                  }}
                                >
                                  {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                                  <div
                                    style={{
                                      marginBottom: "10px",
                                      display: "flex",
                                      gap: "10px",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {/* Month Dropdown */}
                                    <select
                                      style={{
                                        fontSize: "16px",
                                        padding: "6px 10px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                      }}
                                      value={months[date.getMonth()]}
                                      onChange={({ target: { value } }) =>
                                        changeMonth(months.indexOf(value))
                                      }
                                    >
                                      {months.map((month) => (
                                        <option key={month} value={month}>
                                          {month}
                                        </option>
                                      ))}
                                    </select>

                                    {/* Year Dropdown */}
                                    <select
                                      style={{
                                        fontSize: "16px",
                                        padding: "6px 10px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                      }}
                                      value={date.getFullYear()}
                                      onChange={({ target: { value } }) =>
                                        changeYear(value)
                                      }
                                    >
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                  {/* ✅ Optional month navigation below */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <button
                                      onClick={decreaseMonth}
                                      disabled={prevMonthButtonDisabled}
                                      style={{
                                        fontSize: "18px",
                                        padding: "2px 8px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {"<"}
                                    </button>

                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                      }}
                                    >
                                      {months[date.getMonth()]}{" "}
                                      {date.getFullYear()}
                                    </span>

                                    <button
                                      onClick={increaseMonth}
                                      disabled={nextMonthButtonDisabled}
                                      style={{
                                        fontSize: "18px",
                                        padding: "2px 8px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {">"}
                                    </button>
                                  </div>
                                </div>
                              );
                            }}
                          />
                        </Form.Group>
                      </div>
                      <Col
                        lg={12}
                        md={12}
                        xs={12}
                        sm={12}
                        className=" mt-5 locationFields"
                      >
                        <h4>
                          {" "}
                          {t("release_statement_title")}{" "}
                          <span className="text-danger">*</span>
                        </h4>

                        <h5 className="release_statement mt-3">
                          {t("release_statement")}
                        </h5>
                        <div className="d-flex">
                          <div>
                            <label className="form-check-label ml-sm-2 hear_us">
                              <input
                                type="checkbox"
                                className="form-check-input ageLabel acknowledgmentCheck"
                                name="husband_acknowledgment"
                                value="husband_acknowledgment"
                                onChange={acknowledgmentCheckbox}
                                checked={acknowledgments.husband_acknowledgment}
                              />
                              {t("husband_acknowledgment")}
                              <i className="input-helper"></i>
                            </label>
                          </div>
                          <div className="wife_acknowledgement">
                            <label className="form-check-label ml-sm-2 hear_us">
                              <input
                                type="checkbox"
                                className="form-check-input ageLabel acknowledgmentCheck"
                                name="wife_acknowledgment"
                                value="wife_acknowledgment"
                                onChange={acknowledgmentCheckbox}
                                checked={acknowledgments.wife_acknowledgment}
                              />
                              {t("wife_acknowledgment")}
                              <i className="input-helper"></i>
                            </label>
                          </div>
                        </div>
                        {acknowledgmentAlert && (
                          <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className="form-check ml-3"
                          >
                            <span className="text-danger">
                              {t("acknowledgmentAlertMsg")}
                            </span>
                          </Col>
                        )}
                      </Col>

                      <Col lg={12} md={12} xs={12} className="text-center mt-5">
                        <Button variant="primary" type="submit">
                          {t("register")}
                        </Button>
                      </Col>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="content-wrapper align-items-center auth px-0">
              <div className="row w-100 mx-0">
                <div className="col-lg-10 mx-auto">
                  <div className="auth-form-light text-center main-register py-5 px-4 px-sm-5">
                    <h3>No Retreat</h3>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {show ? (
          <AlertModal
            show={show}
            handleClose={handleClose}
            message={`
<p> 
  <strong>${t("his_name")}</strong> ${!data.hisFirstName || data.hisFirstName === "NILL"
                ? "NIL"
                : `${data.hisFirstName} ${data.hisLastName || ""}`
              }<br/>
  <strong> ${t("his_email")}</strong> ${!data.hisEmail || data.hisEmail === "NILL" ? "NIL" : data.hisEmail
              }<br/><br/>
  <strong>${t("her_name")}</strong> ${!data.herFirstName || data.herFirstName === "NILL"
                ? "NIL"
                : `${data.herFirstName} ${data.herLastName || ""}`
              }<br/>
  <strong>${t("her_email")}</strong> ${!data.herEmail || data.herEmail === "NILL" ? "NIL" : data.herEmail
              }
</p>`}
            actionFunction={coupleMatched}
            cancel={t("cancel_button")}
            okay={t("okay_button")}
            heading={t("alert_msg")}
          />
        ) : null}
        {showInfo ? (
          <AlertDelete
            show={showInfo}
            alertHeader={t("register_retreat")}
            alerMessage={
              <div>
                <h5>{matched ? t("matched_mail") : t("not_matched_mail")}</h5>
              </div>
            }
            handleClose={handleCloseInfoAlert}
            buttonText={t("okay_alert_msg")}
          />
        ) : null}

        <OtherParishModal
          show={otherParishModalOpen}
          handleClose={() => setOtherParishModalOpen(false)}
          registerationData={data}
          setRegisterationData={setData}
          setParishList={setParishList}
          parishList={parishList}
        />
      </div>
    </>
  );
};
